import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PharmaPageComponent } from "./pharma-page/pharma-page.component";
import { Routes, RouterModule } from "@angular/router";
import { DrugsByCompanyComponent } from "./drugs-by-company/drugs-by-company.component";
import { DatabasePageComponent } from "./database-page/database-page.component";
import { HighchartsChartModule } from "highcharts-angular";

import { FormsModule } from "@angular/forms";
import { NzResizableModule } from "ng-zorro-antd/resizable";
import { DrugsByMoaComponent } from "./drugs-by-moa/drugs-by-moa.component";
import { DrugsByPhaseComponent } from "./drugs-by-phase/drugs-by-phase.component";
import { DrugsByIndicationComponent } from "./drugs-by-indication/drugs-by-indication.component";
import { DrugsByTherapeuticAreaComponent } from "./drugs-by-therapeutic-area/drugs-by-therapeutic-area.component";
import { GlobalSubheaderModule } from "../global-subheader/global-subheader.module";
import { DatabaseGridControlsComponent } from "./database-grid-controls/database-grid-controls.component";
import {
  ItemPickerComponent,
  ItemPickerModule,
} from "@va/core-library/item-picker";
import { ButtonModule } from "@va/core-library/button";
import { DatabaseColumnPickerComponent } from "./database-column-picker/database-column-picker.component";
import { DatabaseDataSettingsComponent } from "./database-data-settings/database-data-settings.component";
import { IconsModule } from "@va/core-library/icons";
import { CascaderModule } from "@va/core-library/cascader";
import { DatabaseGridComponent } from "./database-grid/database-grid.component";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatMenuModule } from "@angular/material/menu";
import { DatabasePageFacetComponent } from "./database-page-facet/database-page-facet.component";
import { DatabasePageSiderComponent } from "./database-page-sider/database-page-sider.component";
import { SharedModule } from "../shared/shared.module";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { PeriodFilterModule } from "@va/core-library/period-filter";
import { CurrencySelectModule } from "@va/core-library/currency-select";
import { CustomSkeletonModule } from "@va/core-library/custom-skeleton";
import { DatabaseFacetSelectedFiltersComponent } from "./database-facet-selected-filters/database-facet-selected-filters.component";
import { NzModalModule } from "ng-zorro-antd/modal";
import { NzGridModule } from "ng-zorro-antd/grid";
import { NzDropDownModule } from "ng-zorro-antd/dropdown";
import { NzTagModule } from "ng-zorro-antd/tag";
import { NzSkeletonModule } from "ng-zorro-antd/skeleton";
import { NzSpinModule } from "ng-zorro-antd/spin";
import { NzSelectModule } from "ng-zorro-antd/select";
import { NzSwitchModule } from "ng-zorro-antd/switch";
import { NzLayoutModule } from "ng-zorro-antd/layout";
import { NzCollapseModule } from "ng-zorro-antd/collapse";
import { NzInputModule } from "ng-zorro-antd/input";
import { NzAutocompleteModule } from "ng-zorro-antd/auto-complete";
import { NzDividerModule } from "ng-zorro-antd/divider";
import { NzCascaderModule } from "ng-zorro-antd/cascader";
import { NzListModule } from "ng-zorro-antd/list";
import { NzTreeModule } from "ng-zorro-antd/tree";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzToolTipModule } from "ng-zorro-antd/tooltip";
import { NzCheckboxModule } from "ng-zorro-antd/checkbox";
import { NzTypographyModule } from "ng-zorro-antd/typography";
import { DrugsByIndicationBarChartComponent } from "./drugs-by-indication-bar-chart/drugs-by-indication-bar-chart.component";
import { DatabaseGridContainerComponent } from "./database-grid-container/database-grid-container.component";
import { DrugPageComponent } from "./drug-page/drug-page.component";
import { DrugSummaryComponent } from "./drug-summary/drug-summary.component";
import { DrugSalesAnalysisComponent } from "./drug-sales-analysis/drug-sales-analysis.component";
import { DrugSalesAnalysisSummarySectionComponent } from "./drug-sales-analysis-summary-section/drug-sales-analysis-summary-section.component";
import { DrugSalesAnalysisGridSectionComponent } from "./drug-sales-analysis-grid-section/drug-sales-analysis-grid-section.component";
import { DrugPageGridComponent } from "./drug-page-grid/drug-page-grid.component";
import { DrugDistributionAnalysisGridControlsComponent } from "./drug-distribution-analysis-grid-controls/drug-distribution-analysis-grid-controls.component";
import { DrugDistributionAnalysisGridComponent } from "./drug-distribution-analysis-grid/drug-distribution-analysis-grid.component";
import { DrugDistributionAnalysisComponent } from "./drug-distribution-analysis/drug-distribution-analysis.component";
import { DrugDistributionAnalysisChartComponent } from "./drug-distribution-analysis-chart/drug-distribution-analysis-chart.component";
import { SaveAndPillsComponent } from "./save-and-pills/save-and-pills.component";
import { DrugSalesSummaryMarketedDrugComponent } from "./drug-sales-analysis-summary-section/drug-sales-summary-marketed-drug/drug-sales-summary-marketed-drug.component";
import { DrugSalesSummaryPipelineDrugComponent } from "./drug-sales-analysis-summary-section/drug-sales-summary-pipeline-drug/drug-sales-summary-pipeline-drug.component";
import { DrugPageGridControlsComponent } from "./drug-page-grid-controls/drug-page-grid-controls.component";
import { DrugDistributionDataRevisionDropdownComponent } from "./drug-distribution-data-revision-dropdown/drug-distribution-data-revision-dropdown.component";
import { MexGridPageModule } from "../mex-grid-page/mex-grid-page.module";

import { NzPopoverModule } from "ng-zorro-antd/popover";
import { NzRadioModule } from "ng-zorro-antd/radio";
import { NzDatePickerModule } from "ng-zorro-antd/date-picker";
import { NzTabsModule } from "ng-zorro-antd/tabs";
import { NzIconModule } from "ng-zorro-antd/icon";
import { NzDrawerModule } from "ng-zorro-antd/drawer";
import { AuditFormulabarComponent } from "./audit-formulabar/audit-formulabar.component";
import { PharmaResearchInsightPopupComponent } from "./pharma-research-insight-popup/pharma-research-insight-popup.component";
import { PharmaDatabaseDataRevisionsDropdownComponent } from "./pharma-database-data-revisions-dropdown/pharma-database-data-revisions-dropdown.component";
import { PharmaAnalystTabLineitemSearchComponent } from "./pharma-analyst-tab-lineitem-search/pharma-analyst-tab-lineitem-search.component";

const pharmaRoutes: Routes = [
  {
    path: "",
    pathMatch: "full",
    redirectTo: "database",
  },
  {
    path: "database",
    pathMatch: "full",
    data: {
      title: "BioPharma-DB",
    },
    component: DatabasePageComponent,
  },
  {
    path: "database/:pageContext",
    component: DatabasePageComponent,
    data: {
      title: "BioPharma-DB",
    },
  },
  {
    path: "drug/:cTagId",
    component: DrugPageComponent,
    data: {
      title: "BioPharma-Drug",
    },
  },
  {
    path: "**",
    redirectTo: "/home",
  },
];

@NgModule({
  imports: [RouterModule.forChild(pharmaRoutes)],
  exports: [RouterModule],
  declarations: [],
})
export class PharmaPageRoutingModule {}

@NgModule({
  declarations: [
    PharmaPageComponent,
    DrugsByCompanyComponent,
    DatabasePageComponent,
    DrugsByMoaComponent,
    DrugsByPhaseComponent,
    DrugsByIndicationComponent,
    DrugsByTherapeuticAreaComponent,
    DatabaseGridControlsComponent,
    DatabaseColumnPickerComponent,
    DatabaseDataSettingsComponent,
    DatabaseGridComponent,
    DatabasePageFacetComponent,
    DatabasePageSiderComponent,
    DatabaseFacetSelectedFiltersComponent,
    DrugsByIndicationBarChartComponent,
    DatabaseGridContainerComponent,
    DrugPageComponent,
    DrugSummaryComponent,
    DrugSalesAnalysisComponent,
    DrugSalesAnalysisSummarySectionComponent,
    DrugSalesAnalysisGridSectionComponent,
    DrugPageGridComponent,
    SaveAndPillsComponent,
    DrugSalesSummaryMarketedDrugComponent,
    DrugSalesSummaryPipelineDrugComponent,
    DrugPageGridControlsComponent,
    DrugDistributionAnalysisChartComponent,
    DrugDistributionAnalysisComponent,
    DrugDistributionAnalysisGridComponent,
    DrugDistributionAnalysisGridControlsComponent,
    DrugDistributionDataRevisionDropdownComponent,
    AuditFormulabarComponent,
    PharmaResearchInsightPopupComponent,
    PharmaDatabaseDataRevisionsDropdownComponent,
    PharmaAnalystTabLineitemSearchComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    PharmaPageRoutingModule,
    HighchartsChartModule,
    NzResizableModule,
    GlobalSubheaderModule,
    MatTableModule,
    MatMenuModule,
    IconsModule,
    CascaderModule,
    InfiniteScrollModule,
    FormsModule,
    ItemPickerModule,
    SharedModule,
    NzCascaderModule,
    ButtonModule,
    IconsModule,
    ScrollingModule,
    MatCheckboxModule,
    MatSortModule,
    PeriodFilterModule,
    CurrencySelectModule,
    CustomSkeletonModule,
    NzModalModule,
    NzDropDownModule,
    NzTagModule,
    NzSkeletonModule,
    NzSpinModule,
    NzSelectModule,
    NzSwitchModule,
    NzLayoutModule,
    NzResizableModule,
    NzCollapseModule,
    NzInputModule,
    NzAutocompleteModule,
    NzDividerModule,
    NzListModule,
    NzTreeModule,
    NzButtonModule,
    NzToolTipModule,
    NzGridModule,
    NzCheckboxModule,
    NzPopoverModule,
    NzRadioModule,
    NzDatePickerModule,
    NzTabsModule,
    NzIconModule,
    NzDrawerModule,
    NzTypographyModule,
    MexGridPageModule,
  ],
  exports: [DrugsByCompanyComponent, DatabasePageSiderComponent],
  entryComponents: [ItemPickerComponent],
})
export class PharmaPageModule {}
